export type TourRole = 'free' | 'premium' | 'business' | 'superadmin';

export interface TourStep {
  element: string;
  popover: {
    title: string;
    description: string;
    side?: 'top' | 'bottom' | 'left' | 'right';
    align?: 'start' | 'center' | 'end';
  };
  roles?: TourRole[]; // undefined = all roles
}

export const TOUR_STEPS: TourStep[] = [
  {
    element: '#tour-logo',
    popover: {
      title: '👋 Καλώς ήρθατε στο AskΦόρος',
      description: 'Ας σας δείξουμε τι μπορεί να κάνει σε 30 δευτερόλεπτα. Πατήστε Επόμενο για να ξεκινήσετε.',
      side: 'right',
      align: 'start',
    },
  },
  {
    element: '#tour-chat-input',
    popover: {
      title: '💬 Ρωτήστε ό,τι θέλετε',
      description: 'Γράψτε οποιαδήποτε ερώτηση για ελληνική φορολογία — απλά στα ελληνικά, όπως θα ρωτούσατε έναν λογιστή.',
      side: 'top',
      align: 'center',
    },
  },
  {
    element: '#tour-citations',
    popover: {
      title: '📖 Νομικές Αναφορές',
      description: 'Κάθε απάντηση συνοδεύεται από επαληθευμένες νομικές αναφορές — νόμοι, ΦΕΚ, εγκύκλιοι ΑΑΔΕ. Κάντε κλικ για να ανοίξετε την επίσημη πηγή.',
      side: 'left',
      align: 'start',
    },
  },
  {
    element: '#tour-nav-news',
    popover: {
      title: '📰 Live Νέα ΑΑΔΕ',
      description: 'Live ενημερώσεις από ΑΑΔΕ, Διαύγεια και TaxHeaven. Μάθετε πρώτοι για κάθε αλλαγή στη νομοθεσία.',
      side: 'right',
      align: 'center',
    },
  },
  {
    element: '#tour-nav-deadlines',
    popover: {
      title: '📅 Ημερολόγιο Προθεσμιών',
      description: 'Όλες οι φορολογικές προθεσμίες σε ένα μέρος — ΦΠΑ, Ε1, ΕΦΚΑ, e-invoicing. Φιλτράρετε ανά τύπο οντότητας.',
      side: 'right',
      align: 'center',
    },
  },
  {
    element: '#tour-nav-simulator',
    popover: {
      title: '🧮 Φορολογικός Προσομοιωτής',
      description: 'Υπολογίστε τον φόρο εισοδήματος, τεκμήρια και ΦΠΑ βάσει των επίσημων 2026 κλιμάκων — πριν υποβάλετε τη δήλωση.',
      side: 'right',
      align: 'center',
    },
    roles: ['premium', 'business', 'superadmin'],
  },
  {
    element: '#tour-nav-clients',
    popover: {
      title: '👥 Διαχείριση Πελατών',
      description: 'Διαχειριστείτε όλους τους πελάτες σας, παρακολουθήστε υποχρεώσεις και λαμβάνετε αυτόματες ειδοποιήσεις email πριν κάθε deadline.',
      side: 'right',
      align: 'center',
    },
    roles: ['business', 'superadmin'],
  },
  {
    element: '#tour-nav-gemi',
    popover: {
      title: '🏢 Μητρώο ΓΕΜΗ',
      description: 'Αναζητήστε οποιαδήποτε ελληνική επιχείρηση με ΑΦΜ, επωνυμία ή αρ. ΓΕΜΗ — με live δεδομένα από το Γενικό Εμπορικό Μητρώο.',
      side: 'right',
      align: 'center',
    },
    roles: ['premium', 'business', 'superadmin'],
  },
  {
    element: '#tour-replay-btn',
    popover: {
      title: '✅ Είστε έτοιμοι!',
      description: 'Αν χρειαστείτε βοήθεια, μπορείτε να ξαναδείτε αυτή την ξενάγηση οποιαδήποτε στιγμή από εδώ.',
      side: 'top',
      align: 'start',
    },
  },
];

export const TOUR_STORAGE_KEY = 'askforos_tour_v1';
